export enum BinListRowAction {
  EDIT_QTY = 'edit_qty',
  EDIT_INVENTORY_NUMBER = 'edit_inventory_number',
  EDIT_BIN_TYPE = 'edit_bin_type',
  EDIT_COMMODITY = 'edit_commodity',
}
